import { Center, Text } from "@chakra-ui/react";

interface Props {
  color: { name: string; color: string };
  selectedColor: string;
  setSelectedColor: (color: string) => void;
}

const ColorPill = ({ color, selectedColor, setSelectedColor }: Props) => {
  return (
    <Center
      borderWidth={color.color === selectedColor ? 2 : ""}
      borderColor={"WhiteAlpha.900"}
      role="group"
      _hover={{
        cursor: "pointer",
        bg: color.color + ".400",
      }}
      transition={"0.4s"}
      borderRadius={"md"}
      key={color.name}
      h={"35px"}
      width={color.color === selectedColor ? "85px" : "30px"}
      px={2}
      bg={
        color.color === selectedColor
          ? `${color.color}.500`
          : `${color.color}.600`
      }
      onClick={() => setSelectedColor(color.color)}
    >
      {color.color === selectedColor && (
        <Text fontWeight={"bold"} color={`${color.color}.700`}>
          {color.name}
        </Text>
      )}
    </Center>
  );
};

export default ColorPill;
